import {
  SIGNIN,
  SIGNOUT
} from "./types";

export const authenticate = () => ({
  type: SIGNIN
});

export const unauthenticate = () => ({
  type: SIGNOUT
});
